import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = ["d"]

import { computed } from 'vue'
import { mdiAlert, mdiCheck, mdiClose, mdiMinus, mdiTimerSand } from '@mdi/js'

import { EffectiveRegistrationStatus } from '@/constants/ds-attendance.constants'

import { COMPLIANCE_STATE_TITLES, REGISTRATION_STATUS_LABELS } from '../constants'
import type { ComplianceState, RegistrationStatusValue } from '../types'

interface StateConfig {
  icon: string
  colorClass: string
  bg: string
}

// O texto do tooltip vem de COMPLIANCE_STATE_TITLES — compartilhado com os
// aria-labels das células de domínio para o estado ser anunciado igual.

export default /*#__PURE__*/_defineComponent({
  __name: 'ComplianceIcon',
  props: {
    state: {},
    domainLabel: {},
    registrationStatus: {}
  },
  setup(__props: any) {

const props = __props;



const CONFIG: Record<ComplianceState, StateConfig> = {
  ok: { icon: mdiCheck, colorClass: 'text-sucess', bg: '#EAFBEF' },
  fail: { icon: mdiClose, colorClass: 'text-negative', bg: '#FCE9EA' },
  pending: { icon: mdiMinus, colorClass: 'text-neutral50', bg: '#F0F0F4' },
  // Q1 — neutro: o traço cinza diz "não se aplica", nunca "falhou".
  not_required: { icon: mdiMinus, colorClass: 'text-neutral50', bg: '#F0F0F4' }
}

/**
 * Os quatro estados do registro. Ícone E cor mudam juntos nos quatro: cor
 * sozinha não passa em daltonismo, e a bolinha não tem rótulo visível.
 *
 * `PENDING` é ampulheta cinza-azul, e não vermelho: existe registro enviado e
 * ainda não auditado, então cobrar o médico seria cobrar algo em curso.
 */
const REGISTRATION_CONFIG: Record<RegistrationStatusValue, StateConfig> = {
  [EffectiveRegistrationStatus.OK]: { icon: mdiCheck, colorClass: 'text-sucess', bg: '#EAFBEF' },
  [EffectiveRegistrationStatus.PARTIAL]: {
    icon: mdiAlert,
    colorClass: 'text-alert',
    bg: '#FDF0DF'
  },
  [EffectiveRegistrationStatus.PENDING]: {
    icon: mdiTimerSand,
    colorClass: 'text-slate-500',
    bg: '#EEF2F8'
  },
  [EffectiveRegistrationStatus.NONE]: {
    icon: mdiClose,
    colorClass: 'text-negative',
    bg: '#FCE9EA'
  },
  // Q1 — plantão fora do time: registro não exigido, traço cinza neutro.
  [EffectiveRegistrationStatus.NOT_REQUIRED]: {
    icon: mdiMinus,
    colorClass: 'text-neutral50',
    bg: '#F0F0F4'
  }
}

// Valor desconhecido (estado novo do backend) NÃO cai num ícone inventado: volta
// para a bolinha de conformidade, que é sempre verdadeira.
const registrationConfig = computed(() =>
  props.registrationStatus
    ? (REGISTRATION_CONFIG[props.registrationStatus as RegistrationStatusValue] ?? null)
    : null
)

const config = computed(() => registrationConfig.value ?? CONFIG[props.state])

const tooltipText = computed(() => {
  const stateTitle = registrationConfig.value
    ? REGISTRATION_STATUS_LABELS[props.registrationStatus as RegistrationStatusValue]
    : COMPLIANCE_STATE_TITLES[props.state]
  return props.domainLabel ? `${props.domainLabel} — ${stateTitle}` : stateTitle
})

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", {
      class: "flex items-center justify-center w-6 h-6 rounded-full",
      style: _normalizeStyle({ backgroundColor: config.value.bg })
    }, [
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(['w-4 h-4', config.value.colorClass]),
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          d: config.value.icon,
          fill: "currentColor"
        }, null, 8, _hoisted_2)
      ], 2))
    ], 4),
    _createVNode(_component_v_tooltip, {
      activator: "parent",
      location: "top",
      text: tooltipText.value
    }, null, 8, ["text"])
  ]))
}
}

})